import request from '@/utils/request'

//个案咨询列表
export function consultList(data) {
    return request({
        url: '/backend/consult/consultList',
        method: 'post',
        data: data
    })
}

//获取个案咨询信息
export function consultInfo(data) {
    return request({
        url: '/backend/consult/consultInfo',
        method: 'post',
        data: data
    })
}

//个案咨询信息保存
export function consultDataSave(data) {
    return request({
        url: '/backend/consult/consultDataSave',
        method: 'post',
        data: data
    })
}

//个案咨询状态修改
export function consultStatusSave(data) {
    return request({
        url: '/backend/consult/consultStatusSave',
        method: 'post',
        data: data
    })
}

export function consultDelete(data) {
    return request({
        url: '/backend/consult/consultDelete',
        method: 'post',
        data: data
    })
}


//个案咨询标签列表
export function consultTagList(data) {
    return request({
        url: '/backend/consult/consultTagList',
        method: 'post',
        data: data
    })
}

//个案咨询老师扩展信息
export function consultTeacherExtraInfo(data) {
    return request({
        url: '/backend/consult/consultTeacherExtraInfo',
        method: 'post',
        data: data
    })
}

//个案咨询编辑扩展信息
export function createUpdateTeacherExtra(data) {
    return request({
        url: '/backend/consult/createUpdateTeacherExtra',
        method: 'post',
        data: data
    })
}